export const inputWidth = { width: 130 };
export const dateWidth = { width: 160 };
